import addActivePolicyTags from '../services/addActivePolicyTags';
import getAvailablePoliciesListState from '../selectors/getAvailablePoliciesListState';
import {
    onAddActivePolicyTagsRequestComplete,
    updateUserConfigurationOnAddPolicy,
} from '../actions/internalActions';
import { trace } from 'owa-trace';

/**
 * Function executed when 'Save' button is clicked from the retention policy page
 */
export default async function saveRetentionPoliciesEdit(): Promise<void> {
    try {
        const selectedPolicies = [
            ...getAvailablePoliciesListState().retentionPolicies.values(),
        ].filter(tag => tag.isChecked);
        const rawRetentionIds = selectedPolicies.map(tag => tag.Identity.RawIdentity);
        if (rawRetentionIds.length) {
            const response = await addActivePolicyTags(rawRetentionIds);
            onAddActivePolicyTagsRequestComplete();
            if (response.WasSuccessful) {
                // retention policies in user configuration need to be updated so that we can serve updated options from context menu
                updateUserConfigurationOnAddPolicy(selectedPolicies);
            }
        }
    } catch (e) {
        trace.error(e);
    }
    return Promise.resolve(null);
}
